/**
 * 本地调试：强制 iCloud 登录返回 ec=10005（Apple ID locked）。
 * 仅工作区 / .env.local 使用，默认禁止提交为开启态。
 *
 * 优先级：
 * 1. localStorage `DEBUG_FORCE_ICLOUD_10005` = '1' | '0'（控制台可即时开关）
 * 2. 未写 localStorage 时读 `NEXT_PUBLIC_DEBUG_FORCE_ICLOUD_10005`
 */
export const DEBUG_FORCE_ICLOUD_10005_KEY = 'DEBUG_FORCE_ICLOUD_10005'

export const isDebugForceIcloud10005 = () => {
  if (typeof window !== 'undefined') {
    try {
      const stored = window.localStorage.getItem(DEBUG_FORCE_ICLOUD_10005_KEY)
      if (stored === '1') return true
      if (stored === '0') return false
    } catch {
      // ignore
    }
  }

  return process.env.NEXT_PUBLIC_DEBUG_FORCE_ICLOUD_10005 === '1'
}

/** 模拟接口成功体，与真实 iosLoginVerification 响应形状一致 */
export const buildDebugIcloud10005Response = () => ({
  data: {
    ec: 10005,
    em: 'Apple ID locked'
  }
})
